// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReservationManagement-space1-UpVxG {
	margin-bottom: 6px !important;
}

.ReservationManagement-space2-F4mWl {
	margin-bottom: 12px !important;
}

.ReservationManagement-space3-Z4YQa {
	margin-bottom: 18px !important;
}

.ReservationManagement-space4-M343j {
	margin-bottom: 24px !important;
}

.ReservationManagement-space5-yfRrq {
	margin-bottom: 30px !important;
}

.ReservationManagement-space6-DLzFI {
	margin-bottom: 36px !important;
}

.ReservationManagement-space7-oPr2k {
	margin-bottom: 42px !important;
}

.ReservationManagement-space8-K4Iw7 {
	margin-bottom: 48px !important;
}

.ReservationManagement-spaceTop1-V81RV {
	margin-top: 6px !important;
}

.ReservationManagement-spaceTop2-SKMxe {
	margin-top: 12px !important;
}

.ReservationManagement-spaceTop3-fk9u6 {
	margin-top: 18px !important;
}

.ReservationManagement-spaceTop4-mt_r4 {
	margin-top: 24px !important;
}

.ReservationManagement-spaceTop5-w_rSI {
	margin-top: 30px !important;
}

.ReservationManagement-spaceTop6-yTGqg {
	margin-top: 36px !important;
}

.ReservationManagement-spaceTop7-VepKX {
	margin-top: 42px !important;
}

.ReservationManagement-spaceTop8-cGOly {
	margin-top: 48px !important;
}

.ReservationManagement-noMargin-cRYdN {
	margin: 0px !important;
}

.ReservationManagement-padding1-l4IhK {
	padding-bottom: 6px !important;
}

.ReservationManagement-padding2-ukhgx {
	padding-bottom: 12px !important;
}

.ReservationManagement-padding3-XNGaP {
	padding-bottom: 18px !important;
}

.ReservationManagement-padding4-iKgTt {
	padding-bottom: 24px !important;
}

.ReservationManagement-padding5-yP9D2 {
	padding-bottom: 30px !important;
}

.ReservationManagement-padding6-eXnvL {
	padding-bottom: 36px !important;
}

.ReservationManagement-padding7-o40Ft {
	padding-bottom: 42px !important;
}

.ReservationManagement-paddingTop1-enU22 {
	padding-top: 6px !important;
}

.ReservationManagement-paddingTop2-FpKr7 {
	padding-top: 12px !important;
}

.ReservationManagement-paddingTop3-AAsCm {
	padding-top: 18px !important;
}

.ReservationManagement-paddingTop4-SGy0l {
	padding-top: 24px !important;
}

.ReservationManagement-paddingTop5-Yro4u {
	padding-top: 30px !important;
}

.ReservationManagement-paddingTop6-_6pkX {
	padding-top: 36px !important;
}

.ReservationManagement-paddingTop7-mfC3H {
	padding-top: 42px !important;
}

.ReservationManagement-noPadding-Kp4hV {
	padding: 0px !important;
}

.ReservationManagement-spaceMarginBottom0-pSdPg {
	margin-bottom: 0;
}

.ReservationManagement-textBold-PJCb8 {
	font-weight: 500 !important;
}

.ReservationManagement-textBolder-nh3A5 {
	font-weight: 700 !important;
}

.ReservationManagement-textNormal-QZFA1 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ReservationManagement-textDarkBlue-mIYhS {
	color: rgb(20, 39, 94) !important;
}

.ReservationManagement-textLightBlue-lgAeu {
	color: rgb(57, 87, 106) !important;
}

.ReservationManagement-textLightSandleGreen-kXTl2 {
	color: rgb(76, 86, 41) !important;
}

.ReservationManagement-textLightBrown-dQziP {
	color: rgb(115, 79, 33) !important;
}

.ReservationManagement-textMediumMaroon-FhEBm {
	color: rgb(87, 37, 51) !important;
}

.ReservationManagement-textBrown-Sfdae {
	color: rgb(160, 47, 24) !important;
}

.ReservationManagement-textMaroon-KTzDq {
	color: rgb(155, 49, 67) !important;
}

.ReservationManagement-textDarkBrown-P11Sg {
	color: rgb(83, 18, 16) !important;
}

.ReservationManagement-textMediumBrown-HIoW3 {
	color: rgb(142, 28, 10) !important;
}

.ReservationManagement-textSkyBlue-bq1AA {
	color: rgb(37, 117, 141) !important;
}

.ReservationManagement-textGray-wbsIc {
	color: rgb(77, 65, 51) !important;
}

.ReservationManagement-errorMessage-6oRE2 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ReservationManagement-userText-XDgzI {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ReservationManagement-panelHeader-ecy8q {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ReservationManagement-exportSection-kCQYR {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ReservationManagement-exportSectionGridSub-DD7JK {
	grid-template-columns: 50% 49% !important;
}

.ReservationManagement-exportText-Vvcvl {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ReservationManagement-exportLinkImg-IpXKr {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ReservationManagement-exportImg-zyhUP {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ReservationManagement-linkBtn-sZApa {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ReservationManagement-table-qqyP6 {
	display: table;
}

.ReservationManagement-tableRow-X70XW {
	display: table-row;
}

.ReservationManagement-tableCell-P7SuQ {
	display: table-cell;
	float: none;
}

.ReservationManagement-formGroup-edcCd {
	margin-bottom: 6px;
}

.ReservationManagement-marginTop0-dd1XK {
	margin-top: 0;
}

.ReservationManagement-marginBottom20-FI6P3 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ReservationManagement-bannerImageBg-PCrLK {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ReservationManagement-bannerDelete-oiOnF {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ReservationManagement-exportLink-RzYHd {
	padding-top: 10px;
	padding-right: 10px;
}

.ReservationManagement-seachContent-FsGBR {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ReservationManagement-marginBottom9-GQQKV {
	margin-bottom: 9px;
}

.ReservationManagement-spaceTop52-BW2j6 {
	margin-top: 52px;
}

.ReservationManagement-profileViewInner-XqMsh {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ReservationManagement-profileViewMain-zJaez {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ReservationManagement-profileViewlabel-zOl3a {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ReservationManagement-profileViewMainContent-TwiIU {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ReservationManagement-reviewsFormStar-R2A56 {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ReservationManagement-reviewsFormStar-R2A56 svg {
	cursor: pointer;
}

.ReservationManagement-addLanguageText-l4T5d {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ReservationManagement-exportSection-kCQYR {
		grid-template-columns: 100%;
	}

	.ReservationManagement-spaceTop52-BW2j6 {
		margin-top: 18px;
	}

	.ReservationManagement-exportText-Vvcvl {
		float: none;
		margin-top: 12px;
	}

	.ReservationManagement-exportSectionGridSub-DD7JK {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ReservationManagement-profileViewlabel-zOl3a {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ReservationManagement-profileViewMainContent-TwiIU {
		width: 100%;
		text-align: center;
	}

	.ReservationManagement-panelHeader-ecy8q {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ReservationManagement-ChangeToUpperCase-C21Oa{
    text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ReservationManagement/ReservationManagement.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACvN3E;IACI,yBAAyB;AAC7B","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n.ChangeToUpperCase{\n    text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ReservationManagement-space1-UpVxG`,
	"space2": `ReservationManagement-space2-F4mWl`,
	"space3": `ReservationManagement-space3-Z4YQa`,
	"space4": `ReservationManagement-space4-M343j`,
	"space5": `ReservationManagement-space5-yfRrq`,
	"space6": `ReservationManagement-space6-DLzFI`,
	"space7": `ReservationManagement-space7-oPr2k`,
	"space8": `ReservationManagement-space8-K4Iw7`,
	"spaceTop1": `ReservationManagement-spaceTop1-V81RV`,
	"spaceTop2": `ReservationManagement-spaceTop2-SKMxe`,
	"spaceTop3": `ReservationManagement-spaceTop3-fk9u6`,
	"spaceTop4": `ReservationManagement-spaceTop4-mt_r4`,
	"spaceTop5": `ReservationManagement-spaceTop5-w_rSI`,
	"spaceTop6": `ReservationManagement-spaceTop6-yTGqg`,
	"spaceTop7": `ReservationManagement-spaceTop7-VepKX`,
	"spaceTop8": `ReservationManagement-spaceTop8-cGOly`,
	"noMargin": `ReservationManagement-noMargin-cRYdN`,
	"padding1": `ReservationManagement-padding1-l4IhK`,
	"padding2": `ReservationManagement-padding2-ukhgx`,
	"padding3": `ReservationManagement-padding3-XNGaP`,
	"padding4": `ReservationManagement-padding4-iKgTt`,
	"padding5": `ReservationManagement-padding5-yP9D2`,
	"padding6": `ReservationManagement-padding6-eXnvL`,
	"padding7": `ReservationManagement-padding7-o40Ft`,
	"paddingTop1": `ReservationManagement-paddingTop1-enU22`,
	"paddingTop2": `ReservationManagement-paddingTop2-FpKr7`,
	"paddingTop3": `ReservationManagement-paddingTop3-AAsCm`,
	"paddingTop4": `ReservationManagement-paddingTop4-SGy0l`,
	"paddingTop5": `ReservationManagement-paddingTop5-Yro4u`,
	"paddingTop6": `ReservationManagement-paddingTop6-_6pkX`,
	"paddingTop7": `ReservationManagement-paddingTop7-mfC3H`,
	"noPadding": `ReservationManagement-noPadding-Kp4hV`,
	"spaceMarginBottom0": `ReservationManagement-spaceMarginBottom0-pSdPg`,
	"textBold": `ReservationManagement-textBold-PJCb8`,
	"textBolder": `ReservationManagement-textBolder-nh3A5`,
	"textNormal": `ReservationManagement-textNormal-QZFA1`,
	"textDarkBlue": `ReservationManagement-textDarkBlue-mIYhS`,
	"textLightBlue": `ReservationManagement-textLightBlue-lgAeu`,
	"textLightSandleGreen": `ReservationManagement-textLightSandleGreen-kXTl2`,
	"textLightBrown": `ReservationManagement-textLightBrown-dQziP`,
	"textMediumMaroon": `ReservationManagement-textMediumMaroon-FhEBm`,
	"textBrown": `ReservationManagement-textBrown-Sfdae`,
	"textMaroon": `ReservationManagement-textMaroon-KTzDq`,
	"textDarkBrown": `ReservationManagement-textDarkBrown-P11Sg`,
	"textMediumBrown": `ReservationManagement-textMediumBrown-HIoW3`,
	"textSkyBlue": `ReservationManagement-textSkyBlue-bq1AA`,
	"textGray": `ReservationManagement-textGray-wbsIc`,
	"errorMessage": `ReservationManagement-errorMessage-6oRE2`,
	"userText": `ReservationManagement-userText-XDgzI`,
	"panelHeader": `ReservationManagement-panelHeader-ecy8q`,
	"exportSection": `ReservationManagement-exportSection-kCQYR`,
	"exportSectionGridSub": `ReservationManagement-exportSectionGridSub-DD7JK`,
	"exportText": `ReservationManagement-exportText-Vvcvl`,
	"exportLinkImg": `ReservationManagement-exportLinkImg-IpXKr`,
	"exportImg": `ReservationManagement-exportImg-zyhUP`,
	"linkBtn": `ReservationManagement-linkBtn-sZApa`,
	"table": `ReservationManagement-table-qqyP6`,
	"tableRow": `ReservationManagement-tableRow-X70XW`,
	"tableCell": `ReservationManagement-tableCell-P7SuQ`,
	"formGroup": `ReservationManagement-formGroup-edcCd`,
	"marginTop0": `ReservationManagement-marginTop0-dd1XK`,
	"marginBottom20": `ReservationManagement-marginBottom20-FI6P3`,
	"bannerImageBg": `ReservationManagement-bannerImageBg-PCrLK`,
	"bannerDelete": `ReservationManagement-bannerDelete-oiOnF`,
	"exportLink": `ReservationManagement-exportLink-RzYHd`,
	"seachContent": `ReservationManagement-seachContent-FsGBR`,
	"marginBottom9": `ReservationManagement-marginBottom9-GQQKV`,
	"spaceTop52": `ReservationManagement-spaceTop52-BW2j6`,
	"profileViewInner": `ReservationManagement-profileViewInner-XqMsh`,
	"profileViewMain": `ReservationManagement-profileViewMain-zJaez`,
	"profileViewlabel": `ReservationManagement-profileViewlabel-zOl3a`,
	"profileViewMainContent": `ReservationManagement-profileViewMainContent-TwiIU`,
	"reviewsFormStar": `ReservationManagement-reviewsFormStar-R2A56`,
	"addLanguageText": `ReservationManagement-addLanguageText-l4T5d`,
	"ChangeToUpperCase": `ReservationManagement-ChangeToUpperCase-C21Oa`
};
module.exports = ___CSS_LOADER_EXPORT___;
